import { module as ModuleJS } from "modujs";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling

export default class extends ModuleJS {
    constructor(m) {
        super(m);
    }

    init() {
        tippy('[data-tippy-content]', {
            theme: 'primary',
          });
        // tippy(this.el, {
        //     theme: 'primary',
        //   });
    }

    bindEvents(el) {}

    update(newContainer) {}

    destroy(oldContainer) {}
}

